import { useState } from 'react'
import { useLogin } from '../api'

export function AdminLoginPage() {
  const login = useLogin()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    login.mutate(
      { email, password },
      // Hard redirect (full reload), not client-side navigate: wipes the React
      // Query cache so a re-login as a different admin can't surface the prior
      // account's cached data. Mirrors logout() in api/client.ts.
      { onSuccess: () => { window.location.href = '/staff' } },
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950 px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-semibold text-center text-gray-900 dark:text-gray-100 mb-2">
          МММ
        </h1>
        <p className="text-xs text-center text-gray-500 dark:text-gray-400 mb-8 font-mono">
          staff access
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          {login.error && (
            <p className="text-red-500 text-sm text-center">{login.error.message}</p>
          )}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="w-full rounded-lg border border-gray-300 dark:border-gray-700
              bg-white dark:bg-gray-900 px-4 py-2.5
              text-gray-900 dark:text-gray-100
              placeholder-gray-400 dark:placeholder-gray-500
              focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="w-full rounded-lg border border-gray-300 dark:border-gray-700
              bg-white dark:bg-gray-900 px-4 py-2.5
              text-gray-900 dark:text-gray-100
              placeholder-gray-400 dark:placeholder-gray-500
              focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            disabled={login.isPending}
            className="w-full rounded-lg bg-blue-600 hover:bg-blue-700 disabled:opacity-50
              text-white font-medium py-2.5 transition-colors"
          >
            {login.isPending ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  )
}
